<template>
  <div class="exchange-wrap">
    <v-nav class="v-nav" :url="'static/img/logo-blue.png'" :changeMethods="false"></v-nav>
    <div class="title-wrap">
      <v-title class="title" :text="'我们的产品和服务'"></v-title>
    </div>
    <el-carousel class="cards card-rest1" :interval="4000" trigger="click" indicator-position="outside" height="412px">
      <el-carousel-item v-for="item in cardsData" :key="item.id">
        <div class="card-wrap">
          <div class="text">
            <h2>{{item.title}}</h2>
            <p>{{item.con}}</p>
          </div>
          <div class="img">
            <img :src="item.url">
          </div>
        </div>
      </el-carousel-item>
    </el-carousel>
    <v-title :text="'我们的优势'"></v-title>
    <div class="strengths">
      <div class="strength safe">
        <div class="cover"></div>
        <img src="../../assets/img/exchange-safe-icon.png"/>
        <h2>安全</h2>
        <p>多重安全措施保护账户以及资产</p>
      </div>
      <div class="strength extend">
        <div class="cover"></div>
        <img src="../../assets/img/exchange-extend-icon.png"/>
        <h2>高可扩展</h2>
        <p>应用、数据库均支持快速横向扩展，满足用户增量需求</p>
      </div>
      <div class="strength diamond">
        <div class="cover"></div>
        <img src="../../assets/img/exchange-diamond-icon.png"/>
        <h2>高可用</h2>
        <p>原生支持高可用方案，提供定制化功能服务</p>
      </div>
    </div>
    <v-footer class="foot"></v-footer>
  </div>
</template>

<script>
  import VNav from "../plug/Nav";
  import VTitle from "../plug/VTitle";
  import VFooter from "../plug/VFooter";

  export default {
    components: {
      VFooter,
      VTitle,
      VNav
    },
    name: "exchange",
    data() {
      return {
        cardsData: [
          {
            id: 0,
            title: '用户管理',
            con: '实现账户注册流程，银行卡绑定及实名认证',
            url: 'static/img/exchange-p1.png'
          },
          {
            id: 1,
            title: '实时货币信息',
            con: '数字资产币种实时行情信息及K线图动态展示',
            url: 'static/img/exchange-p2.png'
          },
          {
            id: 2,
            title: '交易支持',
            con: '支持币币交易及C2C交易模式',
            url: 'static/img/exchange-p3.png'
          },
          {
            id: 3,
            title: '资产管理',
            con: '支持注册用户进行线下充提，当前已有资产管理及查询',
            url: 'static/img/exchange-p4.png'
          },
          {
            id: 4,
            title: '管理后台',
            con: '提供平台后台管理服务，掌握注册人数及交易总额等平台数据',
            url: 'static/img/exchange-p5.png'
          }
        ]
      };
    }
  }
</script>

<style lang="less" scoped>
  .exchange-wrap {
    .v-nav {
      color: #333333;
    }
    .title-wrap {
      position: relative;
      height: 20%;
      .title {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -100%);
      }
    }
    .cards {
      width: 75%;
      min-width: 800px;
      margin: 128px auto 250px;
      .card-wrap {
        display: flex;
        .text {
          flex: 1;
          h2 {
            font-size: 2.25rem;
            margin-top: 118px;
          }
          p {
            font-size: 1.5rem;
            color: #999999;
            margin-top: 20px;
          }
        }
        .img {
          flex: 1;
          text-align: center;
          img {
            vertical-align: middle;
          }
        }
      }
    }
    .strengths {
      width: 80%;
      height: 50%;
      min-width: 1080px;
      margin: 140px auto 200px;
      display: flex;
      justify-content: space-between;
      .strength {
        width: 366px;
        height: 428px;
        @media screen and (max-width: 1500px) {
          width: 296px;
          height: 388px;
        }
        position: relative;
        color: white;
        cursor: pointer;
        img {
          display: block;
          position: absolute;
          left: 125px;
          top: 115px;
          z-index: 15;
          transition: 500ms;
          @media screen and (max-width: 1500px) {
            width: 90px;
            left: 105px;
          }
        }
        h2 {
          position: absolute;
          text-align: center;
          width: 100%;
          left: 0;
          top: 289px;
          font-size: 1.8rem;
          z-index: 15;
          transition: 500ms;
          @media screen and (max-width: 1500px) {
            top: 259px;
          }
        }
        p {
          position: absolute;
          overflow: hidden;
          text-align: center;
          width: 208px;
          height: 0;
          left: calc(~'50% - 104px');
          bottom: 20px;
          font-size: 1.25rem;
          z-index: 15;
          transition: 500ms;
        }
      }
      .safe {
        background: url("../../assets/img/exchange-safe.png");
        background-size: 100% 100%;
      }
      .extend {
        background: url("../../assets/img/exchange-extend.png");
        background-size: 100% 100%;
        img {
          left: 119px;
          @media screen and (max-width: 1500px) {
            left: 105px;
          }
        }
      }
      .diamond {
        background: url("../../assets/img/exchange-diamond.png");
        background-size: 100% 100%;
        img {
          left: 114px;
          @media screen and (max-width: 1500px) {
            left: 105px;
          }
        }
      }
      .cover {
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        background: rgba(0, 0, 0, .54);
        z-index: 10;
      }
      .strength:hover .cover {
        background: rgba(19, 168, 254, .43);
      }
      .strength:hover img {
        transform: translateY(-57px);
      }
      .strength:hover h2 {
        transform: translateY(-57px);
      }
      .strength:hover p {
        height: 114px;
      }
    }
    .foot {
      height: 100px;
      @media screen and (max-width: 1500px){
        height: 70px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/exchange/Exchange.vue